<template>
  <div class="flex flex-wrap space-y-6 pt-6 lg:flex-nowrap lg:space-x-6 lg:space-y-0">
    <div
      class="w-full max-w-[475px] flex-shrink-0 rounded-xl bg-gray-100 bg-opacity-50 p-4 pb-8 lg:px-6 lg:pb-14 lg:pt-6">
      <h4 class="text-xl leading-snug text-gray-600">
        {{ info.title }}
      </h4>
      <p class="mt-2 font-normal leading-snug text-gray-300">
        {{ info.description }}
      </p>
      <JobModalInput
        label="Your Name"
        placeholder="Your Name"
        :value="inputs.referrer"
        name="referrer"
        type="text"
        :required="true"
        class="mt-6"
        :error="errors.has('referrer') ? 'Please enter your name' : undefined"
        @update:model-value="(value: string) => setSelected(value, 'referrer')" />
      <JobModalInput
        label="Candidate's First Name"
        placeholder="Candidate's First Name"
        :value="inputs.name"
        name="name"
        type="text"
        :required="true"
        class="mt-6"
        :error="errors.has('name') ? 'Please enter candidate\'s first name' : undefined"
        @update:model-value="(value: string) => setSelected(value, 'name')" />
      <JobModalInput
        label="Candidate's Last Name"
        placeholder="Candidate's Last Name"
        :value="inputs.lastName"
        name="lastName"
        type="text"
        :required="true"
        class="mt-6"
        :error="errors.has('lastName') ? 'Please enter candidate\'s last name' : undefined"
        @update:model-value="(value: string) => setSelected(value, 'lastName')" />
      <JobModalInput
        label="Candidate's Email Address"
        placeholder="Candidate's Email Address"
        :value="inputs.email"
        name="email"
        type="email"
        :required="true"
        class="mt-6"
        :error="errors.has('email') ? 'Please enter candidate\'s email address' : undefined"
        @update:model-value="(value: string) => setSelected(value, 'email')" />
    </div>
    <div class="max-w-full flex-shrink-0 flex-grow rounded-xl bg-gray-100 bg-opacity-50 p-4 lg:p-6">
      <h4 class="text-xl leading-snug text-gray-600">
        {{ isCampaignPosition ? 'Links' : attachments.title }}
      </h4>
      <p class="mt-2 font-normal leading-snug text-gray-300">
        {{ isCampaignPosition ? 'Please provide us with your LinkedIn profile' : attachments.description }}
      </p>
      <div class="max-w-md">
        <JobModalInput
          v-if="isCampaignPosition"
          label="LinkedIn"
          placeholder="LinkedIn profile url address"
          :value="inputs.linkedin"
          name="linkedin"
          type="text"
          :required="true"
          class="mt-6"
          :error="
            errors.has('linkedin') ? 'Please enter your LinkedIn profile URL address (starting with http)' : undefined
          "
          @update:model-value="(value: string) => setSelected(value, 'linkedin')" />
        <JobModalInputFile
          v-if="!isCampaignPosition"
          :label="attachments.cv.label"
          :placeholder="attachments.cv.placeholder"
          :value="inputs.cv"
          name="cv"
          type="file"
          :required="true"
          class="mt-6"
          :error="errors.has('cv') ? attachments.cv.error : undefined"
          @update:model-value="(value: FileList | null) => setSelected(value, 'cv')" />
        <JobModalInputFile
          v-if="!isCampaignPosition"
          :label="attachments.cover.label"
          :placeholder="attachments.cover.placeholder"
          :value="inputs.cover"
          name="cover"
          type="file"
          class="mt-6"
          :error="errors.has('cover') ? attachments.cover.error : undefined"
          @update:model-value="(value: FileList | null) => setSelected(value, 'cover')" />
        <JobModalInput
          :label="attachments.links.label"
          :placeholder="attachments.links.placeholder"
          :value="inputs.links"
          name="links"
          type="text"
          class="mt-6"
          @update:model-value="(value: string) => setSelected(value, 'links')" />
      </div>
      <p class="mt-2 max-w-md text-sm text-gray-250">
        {{ attachments.notice }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  type Step1Props = {
    errors: Set<string>
    info: {
      title: string
      description: string
      name: { label: string; placeholder: string; error: string }
      lastName: { label: string; placeholder: string; error: string }
      email: { label: string; placeholder: string; error: string }
    }
    attachments: {
      title: string
      description: string
      cv: { label: string; placeholder: string; error: string }
      cover: { label: string; placeholder: string; error: string }
      links: { label: string; placeholder: string }
      notice: string
    }
    mandatory: string
    cta: string
    inputs: {
      referrer: string
      name: string
      lastName: string
      email: string
      linkedin: string
      cv: FileList | null
      cover: FileList | null
      links: string
    }
    isCampaignPosition: boolean
  }

  defineProps<Step1Props>()

  const emit = defineEmits(['inputChange'])

  function setSelected(
    value: string | FileList | null,
    name: 'referrer' | 'name' | 'lastName' | 'email' | 'linkedin' | 'cv' | 'cover' | 'links'
  ) {
    emit('inputChange', value, name)
  }
</script>
